import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useInstantSearch } from 'react-instantsearch';

const useAlgoliaSearchErrorHandler = () => {
  const { addMiddlewares } = useInstantSearch();

  useEffect(() => {
    const middleware = ({ instantSearchInstance }) => {
      function handleError(searchError) {
        toast.error(searchError.name);
        toast.error(searchError.message);
      }

      return {
        subscribe() {
          instantSearchInstance.addListener("error", handleError);
        },
        unsubscribe() {
          instantSearchInstance.removeListener("error", handleError);
        },
      };
    };

    return addMiddlewares(middleware);
  }, [addMiddlewares]);
  return null
}

export default useAlgoliaSearchErrorHandler